/** 모달 ALERT **/
import Confirm from '@/components/common/modal/alert/confirm/index.vue';
import OtherModal from '@/components/common/modal/Confirm.vue';
import Locale from '@/components/common/modal/Locale';
import BottomRadio from '@/components/common/modal/Bottom+Radio';
import BottomCheck from '@/components/common/modal/Bottom+CheckBox.vue';
import Image from '@/components/common/modal/Image';
import NotSameStoreProduct from '@/components/common/modal/NotSameStoreProduct';
import Coupons from '@/components/common/modal/Coupons';
import Alert from '@/components/common/modal/Alert';
import ChangeOrderState from '@/components/common/modal/ChangeOrderState';
import CheckTimeSpan from '@/components/common/modal/CheckTimeSpan';
import CancelReason from '@/components/common/modal/CancelReason';
import Base from '@/components/common/modal/alert/base';
import Update from '@/components/common/modal/Update';
import Permission from '@/components/common/modal/Permission';
import NativeAlertStateModal from '@/components/common/modal/NativeAlertStateModal.vue';
import BottomInputModal from '@/components/common/modal/Bottom+InputModal.vue';
import MyBarcodeModal from '@/views/my/barcode/MyBarcodeModal.vue';

/** 전체화면 **/

export const modalAlertNames = {
  Base,
  Confirm
};

export const modalNames = {
  Alert,
  Confirm: OtherModal,
  Locale,
  BottomRadio,
  BottomCheck,
  Image,
  NotSameStoreProduct,
  Coupons,
  ChangeOrderState,
  CheckTimeSpan,
  CancelReason,
  Update,
  Permission,
  NativeAlertStateModal,
  BottomInputModal,
  MyBarcodeModal
};
